var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-tile',{class:{
      'pb-2': !_vm.decoder.ignore_tagging,
    },attrs:{"title":_vm.$t('decoderIgnoreTaggingClickToChange')},on:{"click":function($event){_vm.$emit('toggle')}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n        "+_vm._s(_vm.decoder.description)+"\n      ")]),_vm._v(" "),_c('v-list-tile-sub-title',{class:{
          'warning--text': _vm.decoder.ignore_tagging,
        }},[(!_vm.decoder.ignore_tagging)?_c('span',[_vm._v("\n          "+_vm._s(_vm.$t('decoderIgnoreTaggingEnabled'))+"\n        ")]):_c('span',[_vm._v("\n          "+_vm._s(_vm.$t('decoderIgnoreTaggingDisabled'))+"\n        ")])])],1),_vm._v(" "),(_vm.decoder.ignore_tagging)?_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"warning"}},[_vm._v("\n        lock\n      ")])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/DecoderTagSelectExtraTile.vue?vue&type=template&id=70cd566e&
// module id = 2599
// module chunks = 5